import axios from 'axios';

export const gerarDescricaoIA = async (textoPrompt: any) => {
  const token = localStorage.getItem('@Sergipanidade:token');
  
  const response = await axios.post('/api/externo/perguntar', 
    { prompt: textoPrompt },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  
  // O retorno será o JSON do Gemini, trate os nós para pegar o texto de resposta
  return response.data;
};